.<template>
  <div class="panel-full panel guestfull" v-show="isActive">
    <div>
      <div class="guest-lookup">
        
        <button class="btn-small actionbutton" @click="selectDefaultGuest" v-if="defaultGuestId>0">Start Guest Ticket</button>
        <button class="btn-small actionbutton" @click="autoLookupGuest" v-if="startGuestTicketIsGuestLookup">Start Guest Ticket</button>
        <input ref="lookupguest" type="search" :placeholder="guestlookuptext" class="textbox" v-model="lookupString" @keyup.enter="lookupGuest()" v-if="showLookupGuest"/>
        <button class="btn-small actionbutton" @click="lookupGuest" v-if="showLookupGuest">Lookup</button>
        
        <addguest :guestId="-1" @refresh="refresh" :isNew="paramTrue" class="newbutton" v-if="showAddGuest"/>
      </div>
    </div>

    <div  class="scrollbox">
      <div v-if="pleaseWait">
        <label class="pleasewait" for>Please Wait...</label>
      </div>
      <div :class="guestclass(g)" v-for="g in guestList" :key="g.id" :value="g.id" @click="selectGuest(g)">
        <div class="horizFlexStretch">
          <label class="text subtitle" for>{{g.name}}</label>
          <label class="text" for>{{guest.PhoneNumber}}</label>
          <updateguest :guestId="g.id" @refresh="refresh" v-show="showUpdate(g)" class="editbutton"/>
        </div>
      </div>
      
      <div >
        <label class="text subtitle" for>{{responseMessage}}</label>
      </div>
    </div>
    

    <div class="nextbutton">
      <button class="btn" @click="toNext" v-show="isValid">Continue to Cart</button>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import dataModel from '../../store/dataModel'
import updateguest from '../../components/actions/updateguest.vue'
import addguest from '../../components/actions/addguest.vue'
import pos from '../../services/pos.js'
export default {
  components:{
    updateguest,
    addguest
  },
  data() {
    return {
      guestlookuptext: "Lookup Guest",
      paramTrue:true,
    };
  },
  mixins:[dataModel,pos],
  props: ["panelIndex"],
  computed: {
    ...mapFields([
            'panels',
     
            
        ]),
        
    isActive: function() {
      return this.panels[this.panelIndex].active;
    },
    isValid: function() {
      return this.panels[this.panelIndex].valid;
    },
    priorValid: function() {
      return this.panels[this.panelIndex - 1].valid;
    },
    
  },
  watch:{
    isActive:function(val){
      if(this.isActive){this.show()}
    }
  },
  methods: {
   show(){
    this.$nextTick(() => {
      this.$refs.lookupguest.focus();
    })
   },
   
    toNext: function() {
      console.log('in guest tonext')
      this.resetGuest();
      
      var nextPanelIndex = Number(this.panelIndex) + 1;
      this.$store.dispatch('setActivePanel',nextPanelIndex); 
    },
    resetGuest(){
      this.guestList=[]
      this.lookupString=""
    }
  }
};
</script>

<style scoped>
.guestfull {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 80px auto 80px;
  grid-template-areas:
    "lookup"
    "details"
    "next";
}

.guest-lookup {
  grid-area: lookup;
  display: flex;
  flex-direction: row;
}
.guestdetails {
  grid-area: details;

  display: flex;
  flex-direction: column;
}

.updateguestbutton {
  margin: 20px 0px 0px 5px;
}
.scrollbox{
  height:450px;
  overflow-y: scroll;
  overflow-x:hidden;
}
.newbutton{
  margin:20px 20px 20px 20px;
}

.editbutton{
  margin:10px;
}
</style>